let graphicLayer; //展示线标记和面标记功能临时用。
let geoJsonLayer; //展示测试征拆区域用。
let tempMarkDrawGraphicLayer; //展示测试征拆区域的红线用。
let redLine;

/* 异步加载 一些弹窗组件 */
const BimDemolitionTree = () =>
  import("./demolitionListTree/DemolitionListTree");
const BimDemolitionCategory = () =>
  import("./bimDemolitionCategory/BimDemolitionCategory.vue");
const BimDemolitionArea = () =>
  import("./bimDemolitionArea/BimDemolitionArea.vue");
const BimDemolitionBlockInfoStat = () =>
  import("./bimDemolitionBlockInfoStat/BimDemolitionBlockInfoStat.vue");
const BimDemolitionBlockInfoBatchModify = () =>
  import(
    "./bimDemolitionBlockInfoBatchModify/BimDemolitionBlockInfoBatchModify.vue"
  );
const BimDemolitionBlockInfo = () =>
  import("./bimDemolitionBlockInfo/BimDemolitionBlockInfo.vue");
const BimDemolitionBlockInfoModify = () =>
  import("./bimDemolitionBlockInfoModify/BimDemolitionBlockInfoModify.vue");

//按需加载
import {
  deleteDemolition,
  getFileDetail,
  getDemolition,
  deleteDemolitionArea,
} from "../../../api/api";

import { EventBus } from "../../../static/js/event-bus.js";
// import globalVC from "@/api/global.js";
// ./files/for-display/demolition_area.json
import { simplifyGeoJSON } from "@/components/tables/shpInfoList/map.js";
export default {
  components: {
    BimDemolitionTree,
    BimDemolitionCategory,
    BimDemolitionArea,
    BimDemolitionBlockInfoStat,
    BimDemolitionBlockInfoBatchModify,
    BimDemolitionBlockInfo,
    BimDemolitionBlockInfoModify,
  },
  props: {},
  data() {
    return {
      bimDemolition_show: true,

      getData: [], //保存请求后台数据获取到的一维json数组【原始数组】
      treeData: [],
      treeExpandAll: true,
      treeNodeKey: "id",

      open_demolition_box: "", //当前打开的标记子弹窗，最多只同时显示一个子弹窗。
      isFold: false,
      loading: false,
    };
  },
  mounted() {
    // alert(22)
    this.initTreeData();

    graphicLayer = new mars3d.layer.GraphicLayer();
    this.$GLOBAL.map.addLayer(graphicLayer);

    EventBus.$on("updateCartesian", (param) => {
      //当标记点移动时，根据标记的id获取到标记的表单信息并显现在表单上，方便准确定位和编辑、更新等。

      // this.$refs.bimDemolitionArea.form.position = param.cartesianXYZ; //这行代码不应该写在这里，因为如果只加载了BimDemolition弹窗，还没有加载DemolitionArea弹窗，那么这段代码应该会报出this.$refs.demolitionArea未定义之类的错误。

      //根据编辑对象的id找到对应标记列表里的数据项，对应进行编辑。
      let tempData = "";
      if (param.mType === "point") {
        tempData = param.cartesianXYZ;
      } else if (param.mType === "polyline" || param.mType === "polygon") {
        tempData = param.points;
      }
      if (tempData) {
        this.editDemolitionAreaByUid(param.mType, param.graphic.uuid, tempData);
      }
    });
  },

  methods: {
    // 初始化列表
    initTreeData() {
      this.$NProgress.configure({
        easing: "ease",
        showSpinner: true,
      });
      this.$NProgress.set(0.8).inc(0.2);
      this.loading = true;
      //axios请求 获取数据 注意将parentId:'0'转为parentId:'',以方便el-tree正常识别和显示数据。此外注意将字段名首位字母改为小写。
      let tempdata = [];
      let that = this;

      let modelData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getDemolition(modelData)
        .then((res) => {
          console.log(res);
          if (
            res.data.data &&
            // res.data.data.length > 0 &&
            res.data.code == 200
          ) {
            tempdata = res.data.data;
            tempdata.forEach((item) => {
              console.log(item);
              item.demolitionType = "directory";
              item.children.forEach((i) => {
                i.demolitionType = "point";
              });
            });

            this.treeData = tempdata;
            //alert(1);
          } else {
            that.$alert("网络不加，请求错误！！", "请刷新页面", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
            this.treeData = [];
            // that.getData=[];
            // that.refreshTree();
          }
          this.$NProgress.done(true);
          this.loading = false;
        })
        .catch((res) => {
          that.$alert("网络不加，请求错误！！", "请刷新页面", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        });
    },
    refreshTree() {
      this.treeData = this.getTree(this.getData, "");
      // console.log(JSON.parse(JSON.stringify(this.getData)));
      // console.log(444);
      // console.log(JSON.parse(JSON.stringify(this.treeData)));
    },
    getTree(data, root, idTxt, pidTxt, pushTxt) {
      var idTxt = idTxt || "id";
      var pidTxt = pidTxt || "parentId";
      var pushTxt = pushTxt || "children";
      // 递归方法
      function getNode(id) {
        var node = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i][pidTxt] == id) {
            let tdata = getNode(data[i][idTxt]);
            if (!tdata) {
              tdata = [];
            }
            data[i][pushTxt] = tdata;
            node.push(data[i]);
          }
        }
        if (node.length == 0) {
          return;
        } else {
          return node;
        }
      }
      // 使用根节点
      return getNode(root);
    },
    bimDemolition_click() {
      //alert("触发");
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }

      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("bimDemolitionBox_close");
    },

    //弹出表单新增标记目录
    createBimDemolitionCategory(data) {
      let fdata = data.filter(function (fp) {
        return fp.demolitionType === "directory";
      });

      this.open_demolition_box = "BimDemolitionCategory";

      this.$refs.bimDemolitionCategory.addDirectory(fdata);
    },
    //目录树添加新增的标记目录
    addBimDemolitionCategory(data) {
      this.$refs.bimDemolitionTree.treeAddItem(data);

      this.getData.push(data);
    },
    // 弹出表单修改标记目录
    editTreeItem(data) {
      // 打开编辑弹窗
      let fdata = this.getData.filter(function (fp) {
        return fp.demolitionType === "directory" && fp.id !== data.id;
      });

      this.open_demolition_box = "BimDemolitionCategory";

      this.$refs.bimDemolitionCategory.editDirectory(data, fdata);
    },
    // 目录树更新已修改成功的标记目录
    updateTreeItem(data) {
      this.$refs.bimDemolitionTree.treeEditItem(data);
    },
    // 删除目录
    deleteTreeItem(data) {
      let that = this;
      this.$confirm("确定删除该分类吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除树节点
          if (data.children == undefined || data.children.length <= 0) {
            //axios请求删除节点代码
            let mddData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              id: data.id,
            };
            deleteDemolition(mddData).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(444444444444);
              if (res.data.success && res.data.code === 204) {
                that.initTreeData(); //请求后台数据刷新
                //this.$refs.bimDemolitionTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。
                //同时还要关闭第二个弹窗，避免已删除的信息的编辑弹窗还在。
                that.open_demolition_box = "";

                that.$notify({
                  title: "已成功删除该分类。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("删除该分类失败了，请再试一次吧~", "删除失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          } else {
            this.$alert("删除失败，因为该分类下内容不为空。", "友情提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    //弹出新增标记弹窗
    createDemolitionArea(data, mType = "point") {
      let fdata = data.filter(function (fp) {
        return fp.demolitionType === "directory";
      });

      // 注意当DemolitionArea的父组件BimDemolition组件的弹窗出现时，DemolitionArea组件就已经加载了，mounted方法也会执行一遍。
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        //alert(2);
        this.$GLOBAL.markDrawGraphicLayer2.clear();
        this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
      }
      this.$GLOBAL.markDrawGraphicLayer2 = new mars3d.layer.GraphicLayer({
        hasEdit: true,
        isAutoEditing: true, //绘制完成后是否自动激活编辑
      });
      this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer2);

      this.$refs.bimDemolitionArea.demolitionArea_click();
      this.open_demolition_box = "BimDemolitionArea";
      this.$refs.bimDemolitionArea.addDemolition(fdata, mType);
    },
    //目录树添加新增的标记
    addDemolitionArea(data) {
      this.$refs.bimDemolitionTree.treeAddItem(data);
      this.getData.push(data);
    },
    // 弹出表单修改标记弹窗。
    async editDemolitionArea(data) {
      console.log(666666666666666);
      // console.log(JSON.parse(JSON.stringify(data)));

      let fdata = this.getData.filter(function (fp) {
        return fp.demolitionType === "directory" && fp.id !== data.id;
      });
      let tempFileList = [];
      //在这里根据localFiles获取文件列表并展示。
      if (data.localFiles) {
        let tempArr = data.localFiles.split(",");
        for (let i = 0; i < tempArr.length; i++) {
          let fData = {
            id: parseInt(tempArr[i]),
          };
          //console.log('555' + i)
          await getFileDetail(fData)
            .then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log('66666666666'+i)
              if (res.data.success && res.data.data) {
                let fileObj = {
                  name: res.data.data.fileOriginName,
                  //如果要预览文件或下载文件则调用专门的api接口，因此这里不需要拼接出url。
                  url: "#",
                  id: fData.id,
                  //'url': process.env.VUE_APP_BASE_API + response.imgUrl
                };
                tempFileList.push(fileObj);
                // console.log(res.data.data);
                // console.log('888888888'+i)
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        }
        // tempArr.map(function(i) {
        // 	let fData = {
        // 		id: parseInt(i)
        // 	}
        // 	await getFileDetail(fData).then(res => {
        // 		console.log(JSON.parse(JSON.stringify(res)));
        // 		console.log('66666666666')
        // 		if (res.data.success && res.data.data) {
        // 			console.log(res.data.data);
        // 			console.log('888888888')
        // 		}
        // 	}).catch(function(err) {
        // 		console.log(err)
        // 	})
        // 	//alert(i)
        // })
        //alert(data.localFiles)
      }
      data.fileList = tempFileList;
      // console.log(JSON.parse(JSON.stringify(tempFileList)));
      // console.log('99999999999')
      // return false;
      console.log(fdata);
      this.$refs.bimDemolitionArea.editDemolition(data, this.treeData);
      this.open_demolition_box = "BimDemolitionArea";
      // console.log(8888888888888);
      // console.log(JSON.parse(JSON.stringify(data)));
      this.demolitionNodeClick(data);
    },
    //根据标记对象uid找到编辑对象的数据
    findDemolitionAreaByUid(uid) {
      return this.getData.filter(function (fp) {
        return fp.uid === uid;
      });
    },

    //根据标记对象id弹出编辑对象的弹窗，适用于用户直接在地图上移动标记时触发该标记的编辑弹窗。
    editDemolitionAreaByUid(mType, uid, tempData = null) {
      let demolitiondata = this.findDemolitionAreaByUid(uid);
      //alert(point)
      if (demolitiondata && demolitiondata.length > 0) {
        //避免地图上标记点移动位置后，移动前弹出表单里填写的信息被重置，且与地图标识显示不同。
        let nowFormData = this.$refs.bimDemolitionArea.data;
        let showData = demolitiondata[0];
        // console.log(55555555555555555555555);
        // console.log(JSON.parse(JSON.stringify(nowFormData)));
        // console.log(JSON.parse(JSON.stringify(showData)));
        //要考虑到一种情况，就是demolitionArea弹窗还在时，切换了移动的标记。
        if (
          nowFormData.id === showData.id &&
          JSON.stringify(nowFormData) != "{}"
        ) {
          // const listAssign = (arrA, arrB) =>
          //   Object.keys(arrA).forEach((key) => {
          //     arrA[key] = arrB[key] || arrA[key];
          //   });
          // listAssign(showData, nowFormData);
          let {
            parentId,
            name,
            desc,
            position,
            fileList,
            fileData,
            demolitionIconColor,
            demolitionTextColor,
            demolitionShared,
            mType,
            points,
          } = nowFormData;
          if (parentId) showData.parentId = parentId;
          if (name) showData.name = name;
          if (desc) showData.desc = desc;
          if (position) showData.position = position;
          if (fileList) showData.fileList = nowFormData.fileList;
          if (fileData) showData.fileData = nowFormData;
          if (demolitionIconColor)
            showData.demolitionIconColor = demolitionIconColor;
          if (demolitionTextColor)
            showData.demolitionTextColor = demolitionTextColor;
          if (demolitionShared !== undefined)
            showData.demolitionShared = demolitionShared;
          if (mType) showData.mType = mType;
          if (points) showData.points = points;
        }
        if (mType) {
          showData.mType = mType;
          if (tempData) {
            if (mType === "point") {
              showData.position = tempData;
            }
            if (mType === "polyline" || mType === "polygon") {
              showData.points = tempData;
            }
          }
        }

        // console.log(newXYZ)
        // console.log(showData.position)
        //console.log(JSON.parse(JSON.stringify(showData)));
        this.$refs.bimDemolitionTree.demolitionEdit(showData);
      }
      // console.log(8888888888888);
      // console.log(JSON.parse(JSON.stringify(demolitiondata)));
    },
    // 目录树更新已修改成功的标记。
    updateDemolitionArea(data) {
      this.$refs.bimDemolitionTree.treeEditItem(data);
    },
    // 删除节点
    deleteDemolitionArea(data) {
      let that = this;
      this.$confirm("确定删除该征迁区域吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除树节点
          // if (data.children == undefined || data.children.length <= 0) {
          //axios请求删除节点代码
          let mrdData = {
            projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
            id: data.id,
          };
          deleteDemolitionArea(mrdData).then((res) => {
            // console.log(JSON.parse(JSON.stringify(res)));
            // console.log(444444444444);
            if (res.data.success && res.data.code === 204) {
              that.open_demolition_box = ""; //清除标记的时候先关闭编辑标记表单，避免标记没了，信息还可以提交。

              that.initTreeData(); //请求后台数据刷新
              //that.$refs.BimDemolitionTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。
              that.$notify({
                title: "已成功删除该征迁区域。",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              that.$alert("删除该征迁区域失败了，请再试一次吧~", "删除失败", {
                confirmButtonText: "确定",
                type: "error",
                callback: (action) => {},
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    removeGeoLayer() {
      if (geoJsonLayer) {
        this.$GLOBAL.map.removeLayer(geoJsonLayer, true);
        geoJsonLayer = null;
      }
      if (redLine) {
        this.$GLOBAL.map.removeLayer(redLine, true);
        redLine = null;
      }
    },
    demolitionNodeClick(data) {
      let that = this;
      console.log(data.children.length);
      // this.$NProgress.inc(0.2);
      // 现阶段展示地图上的征拆区域，及其点击后弹出弹窗的功能。
      // "./files/for-display/demolition_area.json"
      if (data.children.length == 0) {
        let url =
          this.$GLOBAL.localResourcesPath + data.areaTreeDto.blockInfosJsonUrl;
        console.log(data.areaTreeDto.blockInfosJsonUrl);
        this.removeGeoLayer();
        geoJsonLayer = new mars3d.layer.GeoJsonLayer({
          id: data.id,
          name: data.title,
          url:
            //"/baseIP/" + data.areaTreeDto.blockInfosJsonUrl,
            url,
          format: simplifyGeoJSON,
          symbol: {
            type: "polygonCombine",
            styleOptions: {
              color: "#0000FF",
              outline: true,
              outlineWidth: 1.2,
              outlineColor: "#ffffff",
              polygonC: {
                depthFailAppearance: {
                  closed: true,
                },
                visibleDepth: false, //避免被地形遮挡。
                clampToGround: true, //贴地
              },
            },

            styleField: "isOutOfBound",
            styleFieldOptions: {
              1: {
                color: "#ff0000",
                opacity: 0.8,
              },
              0: {
                color: "#207f4c",
                opacity: 0.36,
              },
            },
            visibleDepth: false, //避免被地形遮挡。
            clampToGround: true, //贴地
          },
          flyTo: true,
          // clampToGround: true, //是否贴地
        });
        // 进度条
        this.$NProgress.configure({
          easing: "ease",
          showSpinner: true,
        });
        this.$NProgress.set(0.8).inc(0.2);

        // this.$GLOBAL.map.setCameraView({
        //   lat: 26.165614,
        //   lng: 107.701321,
        //   alt: 1011.8,
        //   heading: 224,
        //   pitch: -87,
        // });

        this.$GLOBAL.map.addLayer(geoJsonLayer);

        //下面代码演示如果再config.json中配置的图层，如何绑定额外事件方法

        let layerTest = this.$GLOBAL.map.getLayer(data.id, "id");
        //绑定事件

        this.$GLOBAL.map.on(mars3d.EventType.addLayer, () => {
          // console.log("数据加载完成");
        });

        layerTest.on(mars3d.EventType.load, () => {
          console.log("数据加载完成");
          this.$NProgress.done(true);
        });

        layerTest.on(mars3d.EventType.click, function (event) {
          //单击事件
          console.log("单击了图层", event);
          // console.log(that.$refs.BimDemolitionBlockInfo.form);
          that.$refs.bimDemolitionBlockInfo.form = event.pickedObject.data.attr;

          that.$refs.bimDemolitionBlockInfoModify.form = JSON.parse(
            JSON.stringify(event.pickedObject.data.attr)
          );
          that.$refs.bimDemolitionBlockInfoModify.initialForm =
            event.pickedObject.data.attr;
          that.open_demolition_box = "BimDemolitionBlockInfo";
        });

        if (tempMarkDrawGraphicLayer) {
          // tempMarkDrawGraphicLayer.clear();
          this.$GLOBAL.map.removeLayer(tempMarkDrawGraphicLayer, true);
          tempMarkDrawGraphicLayer = null;
        }
        tempMarkDrawGraphicLayer = new mars3d.layer.GraphicLayer({
          hasEdit: false,
          // isAutoEditing: true, //绘制完成后是否自动激活编辑
        });
        this.$GLOBAL.map.addLayer(tempMarkDrawGraphicLayer);
        if (data.areaTreeDto != null) {
          console.log("单击了图层", data.areaTreeDto.areaPoints);

          let redLinePoints = data.areaTreeDto.areaPoints;
          let redLinePoints2 = [];
          redLinePoints2.push(redLinePoints);
          // var wallData = {
          //   type: "FeatureCollection",
          //   features: [
          //     {
          //       type: "Feature",
          //       properties: {
          //         // "name": "瑶海区",
          //       },
          //       geometry: {
          //         type: "MultiPolygon",
          //         coordinates: redLinePoints2,
          //       },
          //     },
          //   ],
          // };
          // redLine = null;
          // redLine = new mars3d.layer.GeoJsonLayer({
          //   name: "wall",
          //   data: wallData,
          //   hasEdit: false,
          //   symbol: {
          //     type: "wall",
          //     styleOptions: {
          //       diffHeight: 100, // 墙高
          //       materialType: mars3d.MaterialType.LineFlow,
          //       speed: 10, // 速度
          //       image: "http://mars3d.cn/img/textures/fence.png", // 图片
          //       repeatX: 1, // 重复数量
          //       axisY: true, // 竖直方向
          //       color: "#ee2746", // 颜色
          //       opacity: 0.8, // 透明度
          //     },
          //   },
          //   allowDrillPick: true,
          //   clustering: false,
          // });
          // this.$GLOBAL.map.addLayer(redLine);

          let gl = tempMarkDrawGraphicLayer.addGraphic([
            {
              type: "polyline",
              //positions: this.handlePointsToArray(data[i].points),
              positions: redLinePoints,
              style: {
                color: "#ee2746",
                width: 1.2,
                clampToGround: false,
                visibleDepth: false,
                closure: true,
              },
            },
          ]);
        }
        // tempMarkDrawGraphicLayer.clear();

        this.$message({
          message: "正在地图上绘制征拆区域，请耐心等候片刻。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 3200,
        });
      }

      // 这里不需要标记点，所以先注释掉。
      // if (data.uid) {
      // 	let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
      // 	this.$GLOBAL.markDrawGraphicLayerObj = layer;
      // 	if (data.demolitionType === 'polyline' || data.demolitionType === 'polygon') {
      // 		// 注意这里应该是定位到layer._points，而不是layer._positions。对于polygon和polyline，layer._positions是一个回调函数CallbackProperty，会导致页面卡死。
      // 		this.$GLOBAL.map.flyToPositions(layer._points, {
      // 			minHeight: 100,
      // 			maxHeight: 5000,
      // 			duration: 2,
      // 		});
      // 	} else {
      // 		layer.flyTo({
      // 			minHeight: 100,
      // 			maxHeight: 5000,
      // 			duration: 2,
      // 		});
      // 	}
      // 	layer.hasEdit = true;
      // 	this.$refs.bimDemolitionArea.bindMourseClick(true, data.demolitionType);
      // }
    },
    initDemolitionArray(data) {
      // console.log(data);
      // console.log(1111111);
      //根据数据库加载出来的项目的标记数据显示到地图上。
      if (!this.$GLOBAL.markDrawGraphicLayer) {
        //alert(1);
        this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({
          hasEdit: true,
          isAutoEditing: true, //绘制完成后是否自动激活编辑
        });
        this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer);

        // 这里不需要标记点，所以直接返回data。
        return data;
      }

      let iurl, gl, tposition;
      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(333);
      //this.$GLOBAL.markDrawGraphicLayerArray.length = 0;
      this.$GLOBAL.markDrawGraphicLayer.clear();
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].demolitionType === "point") {
          // if (!data[i].demolitionIconColor) {
          if (!data[i]["demolitionIconColor"]) {
            data[i]["demolitionIconColor"] = this.$GLOBAL.default_markIconColor;
          }
          iurl =
            "/img/marker/mark" +
            data[i]["demolitionIconColor"].slice(1) +
            ".png";
          tposition = data[i].position.split(",");

          gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
            {
              type: "billboard",
              position: new mars3d.LngLatPoint(
                tposition[0],
                tposition[1],
                tposition[2]
              ),
              style: {
                image: iurl,
                //position: data[i].position,
                label: {
                  //不需要文字时，去掉label配置即可
                  text: data[i].name,
                  font_size: 26,
                  font_family: "黑体",
                  color: data[i]["demolitionIconColor"],
                  outline: true,
                  pixelOffsetY: -66,
                  visibleDepth: false,
                },
                visibleDepth: false,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
                // clampToGround: true, //贴地
              },
            },
          ]);
          //gl.position=data[i].position;
          // console.log(gl);
          // console.log(gl[0]._id);
          //console.log(this.$GLOBAL.markDrawGraphicLayer);
          //this.$GLOBAL.markDrawGraphicLayerArray.push(gl);
          data[i].uid = gl[0]._id;
        } else if (data[i].demolitionType === "polyline") {
          // console.log(data[i].points);
          // console.log(this.handlePointsToArray(data[i].points));
          // console.log(12345);
          gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
            {
              type: "polyline",
              positions: this.handlePointsToArray(data[i].points),
              maxPointNum: 70, //可以限定最大点数，70个点绘制后自动结束
              style: {
                color: data[i]["demolitionIconColor"],
                width: 3,
                clampToGround: true,
                visibleDepth: false,
                label: {
                  //不需要文字时，去掉label配置即可
                  text: data[i].name,
                  font_size: 26,
                  font_family: "黑体",
                  color: data[i]["demolitionTextColor"],
                  clampToGround: true,
                  visibleDepth: false,
                },
              },
            },
          ]);
          data[i].uid = gl[0]._id;
        } else if (data[i].demolitionType === "polygon") {
          gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
            {
              type: "polygon",
              positions: this.handlePointsToArray(data[i].points),
              maxPointNum: 70, //可以限定最大点数，70个点绘制后自动结束
              style: {
                color: data[i]["demolitionIconColor"],
                opacity: 0.36,
                outline: true,
                outlineWidth: 2,
                outlineColor: data[i]["demolitionTextColor"],
                clampToGround: true,
                visibleDepth: false,
                opacity: 0.1,
                label: {
                  //不需要文字时，去掉label配置即可
                  text: data[i].name,
                  font_size: 26,
                  font_family: "黑体",
                  color: data[i]["demolitionTextColor"],
                  clampToGround: true,
                  visibleDepth: false,
                },
              },
            },
          ]);
          data[i].uid = gl[0]._id;
        }
        // if(gl){
        // 	data[i].uid = gl[0]._id;
        // }
      }
      this.$GLOBAL.markDrawGraphicLayer.unbindContextMenu(true);
      this.bindLayerContextMenu(this.$GLOBAL.markDrawGraphicLayer);
      return data;
    },
    bindLayerContextMenu(graphicLayer) {
      let that = this;
      graphicLayer.bindContextMenu([
        {
          text: "删除对象",
          iconCls: "fa fa-trash-o",
          show: (event) => {
            const graphic = event.graphic;
            if (!graphic || graphic.isDestroy) {
              return false;
            } else {
              return true;
            }
          },
          callback: function (e) {
            const graphic = e.graphic;
            if (!graphic) {
              return;
            }
            //调用后端接口移除，不应该在这里移除。
            // console.log(e.graphic)
            // console.log(e.graphic.uuid)
            // console.log(121212121212);
            let tempData = that.findDemolitionAreaByUid(e.graphic.uuid);
            if (tempData[0] && tempData[0].id) {
              that.deleteDemolitionArea(tempData[0]);
            }
            //findDemolitionAreaByUid(uid);
            //graphicLayer.removeGraphic(graphic)
          },
        },
      ]);
    },
    handlePointsToArray(points) {
      let rarr = [];
      if (points) {
        let tarr = points.split("|");
        for (let i = 0; i < tarr.length; i++) {
          let t2arr = tarr[i].split(",");
          t2arr = t2arr.map((item) => {
            return Number(item);
          });
          rarr.push(new mars3d.LngLatPoint(t2arr[0], t2arr[1], t2arr[2]));
          //rarr.push(t2arr);
        }
      }
      return rarr;
    },
    showDemolitionStats() {
      this.open_demolition_box = "BimDemolitionBlockInfoStat";
    },
    handleClose() {
      //this.videoDialogVisible=false;
    },
    openBox(boxName = "") {
      if (boxName && boxName.length > 0) {
        this.open_demolition_box = boxName;
      }
    },
    doEditDemolitionInfo() {
      this.open_demolition_box = "BimDemolitionBlockInfoModify";
    },
  },
  watch: {},
  destroyed() {
    if (this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer, true);
    }
    if (this.$GLOBAL.markDrawGraphicLayer2) {
      this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
    }
    this.$GLOBAL.markDrawGraphicLayer = null;
    this.$GLOBAL.markDrawGraphicLayer2 = null;
    this.$GLOBAL.markDrawGraphicLayerObj = null;

    if (graphicLayer) {
      graphicLayer.clear();
      this.$GLOBAL.map.removeLayer(graphicLayer, true);
      graphicLayer = null;
    }
    // 移除EventBus监听器。
    EventBus.$off("updateCartesian");

    //移除geoJSONLayer。
    this.removeGeoLayer();
    if (tempMarkDrawGraphicLayer) {
      tempMarkDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(tempMarkDrawGraphicLayer, true);
      tempMarkDrawGraphicLayer = null;
    }
  },
};
//console.log(localStorage.getItem(ColorPicker));
